module.exports = __webpack_public_path__ + "img/t0-i2.6200ad07.svg";